// Helpers para identificar el dispositivo/navegador desde el que se crean documentos
import { v4 as uuidv4 } from 'uuid'

const DEVICE_ID_KEY = 'habitId'

// Devuelve el id del dispositivo actual. Se genera una única vez por navegador y
// se persiste en localStorage, por lo que sobrevive a cierres del navegador. Se
// pierde (y se genera uno nuevo) si el usuario limpia sus datos o usa modo incógnito
export function getDeviceId() {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY)

  if (!deviceId) {
    deviceId = uuidv4()
    localStorage.setItem(DEVICE_ID_KEY, deviceId)
  }

  return deviceId
}
